import React from 'react';
import { Popover as ElPopover } from 'element-react';
import cx from 'classnames';
import cs from './index.module.scss';

const PopoverWrapper: React.FC<ElementReact.PopoverProps> = ({
  children,
  className,
  trigger = 'hover',
  placement = 'bottom-start',
  visibleArrow = false,
  ...popoverProps
}) => (
  <ElPopover
    {...popoverProps}
    className={cx(cs.popoverWrapper, className)}
    trigger={trigger}
    visibleArrow={visibleArrow}
    placement={placement}
  >
    {children}
  </ElPopover>
);

export default PopoverWrapper;
